module.exports = __webpack_public_path__ + "static/media/DPL_01.f68004e1.jpg";